export const CREATOR_TYPE_OPTIONS = [
  'Content creator',
  'UGC creator',
  'Micro influencer',
  'Videographer',
  'Photographer',
  'Writer',
  'Podcaster',
  'Livestreamer',
  'Blogger',
  'Model',
  'Stylist',
  'Event host',
  'Reviewer',
  'Voice artist',
  'Coach/Instructor',
];

export const NICHE_OPTIONS = [
  'Beauty',
  'Lifestyle',
  'Wellness',
  'Food',
  'Travel',
  'Fashion',
  'Fitness',
  'Tech',
  'Gaming',
  'Parenting',
  'Finance',
  'Home & Decor',
  'Pets',
  'Education',
  'Comedy',
  'Music',
  'Art & Design',
  'Sustainability',
  'Photography',
  'Plants & Gardening',
  'Weddings & Events',
  'Business',
  'Dance',
  'Outdoor & Adventure',
];
